<template>
    <div class="col-md-10 col-lg-8 m-auto">
        <card>
            <h5 class="m-0" slot="header">
                Beställ artikel
            </h5>
            
            <form @submit.prevent="" class="">
                <div class="row">
                    <div class="form-group col-12">
                        <input v-if="!canEdit" type="hidden" name="company_id" v-model="form.company_id">
                        
                        <div v-else>
                            <label >Välj företag</label>

                            <select class="form-control" v-model="company_id" @change="fetchOrderables()">
                                <option v-for="company in companies" :key="company.id" :value="company.id">
                                    {{ company.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group col-12">
                        <label>Namn på artikel</label>
                        <input type="text" class="form-control" :class="{'is-invalid' : hasError.name}" v-model="form.name" />
                        <div class="invalid-feedback">
                            Fyll i ett namn på artikeln.
                        </div>
                    </div>

                    <div class="form-group col-12">
                        <label>Typ av artikel</label>

                        <select class="form-control" v-model="form.orderable">
                            <option v-for="orderable in orderables" :key="orderable.id" :value="orderable.id">
                                {{ orderable.name }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group col-12">
                        <label>Beskrivning</label>
                        <textarea class="form-control" rows="4"  :class="{'is-invalid' : hasError.name}" v-model="form.description"></textarea>
                        <div class="invalid-feedback">
                            Fyll i en beskrivning av artikeln.
                        </div>
                    </div>

                    <div class="form-group col-12">
                        <label>Bilagor</label>
                        <attachments @attached="parseAttachments" />
                    </div>
                </div>
            </form>
            
            <div class="text-right" slot="footer">
                <button :disabled="loading" class="btn btn-info ml-auto" @click="savePrintable">
                    <fa v-if="loading" :icon="['fas','circle-notch']" spin />
                    {{ $t('save') }}
                </button>
            </div>
        </card>
    </div>
</template>
<script>

import store from "~/store";
import axios from "axios";
import Form from "vform";

import Attachments from "~/components/Attachments";

export default {
    middleware: ['auth'],
    components: {
        Attachments
    },
    data() {
        return {
            attachments: new FormData(),
            loading: false,
            creating: false,
            orderables: [],
            company_id: null,
            form: {
                name: "",
                deadline: new Date(),
                company_id: null,
                orderable: null,
                description:""
            },
            hasError: {},
            dpConfig: {
              format: 'YYYY-MM-DD',
              useCurrent: false,
              locale : 'sv',
            }
        };
    },
    created() {
        this.company_id = this.currentCompany;
        this.fetchOrderables();
    },
    watch:{
        
    },
    computed : {
        canEdit() {
            return store.getters["auth/user"].role >= 3;
        },
        currentCompany() {
            return store.getters["auth/company"].id;
        },
        companies() {
            return store.getters["sidebar/companies"];
        }
    },
    methods: {
        parseAttachments(formData){
            this.attachments = formData;
        },
        validate(){
            this.hasError = {};

            if(this.form.name == ''){
                this.hasError.name = true;
                return false
            } 

            if(this.form.description == ''){
                this.hasError.description = true;
                return false
            } 

            return true;
        },
        async fetchOrderables(){
            const { data } = await axios.get('/api/orderable?company_id=' + this.company_id);
            this.orderables = data;
            this.form.company_id = this.company_id;
            this.form.orderable = this.orderables[0].id;
        },
        async savePrintable(routeback) {
            if(!this.validate()){
                return;
            }
            
            this.loading = true;
            let formData = this.attachments;

            for ( var key in this.form ) {
                formData.append(key, this.form[key]);
            }

            try {
                const { data } = await axios.post("/api/printable/order",formData);
                
                if (data.id) {
                    this.$router.push({ 
                        name: 'printables.id',
                        query: {
                            company_id: this.currentCompany
                        },
                        params: {
                            id : data.id
                        }
                    });
                }                
            } catch (error) {
                this.loading = false;
            }

            formData = new FormData();
            this.attachments = formData;
            this.loading = false;
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/printables/order-form.vue